const fetchPageData = require("./fetchPageData");

module.exports = async function fetchServerData({
	bundles,
	layouts,
	endpoint,
	config,
	configs,
}) {
	try {
		if (config.ssr) {
			let fetchedData = await fetchPageData({
				endpoint,
				bundles,
				layouts,
				ssr: true,
				configs,
			});
			if (!fetchedData) {
				throw new Error("No data fetched");
			} else {
				return {
					status: 200,
					headers: {},
					props: {
						...fetchedData,
					},
				};
			}
		} else {
			return {
				status: 200,
				headers: {},
				props: {},
			};
		}
	} catch (error) {
		return {
			status: 500,
			headers: {},
			props: { error: error.message },
		};
	}
};
